import { Component } from '@angular/core';

@Component({
    templateUrl: './mobile-apron.component.html'
})

export class MobileApronComponent {
}
